import { Base64 } from 'js-base64'

export const getQueryObj = () => {
  let url = window.location.search // 获取url中"?"符后的字串
  let theQueryObj = {}
  if (url.indexOf('?') !== -1) {
    const str = url.substr(1)
    const strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theQueryObj[strs[i].split('=')[0]] = strs[i].split('=')[1]
    }
  }
  return theQueryObj
}

export const addQueryStr = variable => {
  const obj = getQueryObj()
  obj[variable] = true
  let arr = []
  for (let key in obj) {
    arr.push([key, obj[key]])
  }
  const query = arr.map(item => item.join('=')).join('&')
  return '?' + query
}

export const getLoginURL = url => {
  const queryStr = addQueryStr('isLogin')
  // console.log(queryStr)
  const val = url
    ? Base64.encode(url)
    : Base64.encode(window.location.origin + window.location.pathname + queryStr)
  // console.log(`https://login.xueersi.com/login/${val}`)
  return `https://login.xueersi.com/login/${val}`
}
export const login = url => {
  window.location.href = getLoginURL(url)
}
export const getRegisterURL = () => {
  const queryStr = addQueryStr('isRegister')
  const url = Base64.encode(window.location.origin + window.location.pathname + queryStr)
  return `https://reg.xueersi.com/reg/${url}`
}
export const register = () => {
  window.location.href = getRegisterURL()
}

export const getLogoutURL = () => {
  const queryStr = addQueryStr('isLogout')
  const url = Base64.encode(window.location.origin + window.location.pathname + queryStr)
  return `https://login.xueersi.com/newLogin/logout/${url}`
}
export const logout = () => {
  window.location.href = getLogoutURL()
}



// WEBPACK FOOTER //
// ./src/util/user.js